import React from 'react';
import Svg, { Path } from 'react-native-svg';

export function VectorTick({ width, height }) {
  return (
    <>
      <Svg
        width="93"
        height="93"
        viewBox="0 0 93 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M46.5 0.5C21.1278 0.5 0.5 21.1278 0.5 46.5C0.5 71.8722 21.1278 92.5 46.5 92.5C71.8722 92.5 92.5 71.8722 92.5 46.5C92.5 21.1278 71.8722 0.5 46.5 0.5ZM46.5 85.8125C24.8259 85.8125 7.1875 68.174 7.1875 46.5C7.1875 24.8259 24.8259 7.1875 46.5 7.1875C68.174 7.1875 85.8125 24.8259 85.8125 46.5C85.8125 68.174 68.174 85.8125 46.5 85.8125ZM68.8571 35.5319C70.1539 34.2351 70.1543 32.1066 68.8583 30.8092C67.5609 29.4926 65.4294 29.4926 64.132 30.8092C64.1314 30.8097 64.1309 30.8103 64.1304 30.8108L39.835 55.1062L28.8668 44.138C27.5696 42.8408 25.4401 42.8408 24.1429 44.138C22.8457 45.4353 22.8457 47.5647 24.1429 48.8619L37.473 62.192C38.12 62.839 38.9768 63.1738 39.835 63.1738C40.6931 63.1738 41.5499 62.839 42.1969 62.192L68.8571 35.5319Z"
          fill="#4BB543"
          stroke="#4BB543"
        />
      </Svg>
    </>
  );
}
